import {useCallback} from 'react';

import {type DispatchableAction} from '../../../types/redux';
import type {BaseSearchHistoryItem} from '../types';
// @ts-ignore TODO How to get this type in without breaking weave?
import {produceSearchHistory} from './produceSearchHistory';

export const useAddToHistory = <T extends BaseSearchHistoryItem>(
  updateSearchHistory: (searchHistory: T[] | undefined) => DispatchableAction,
  currentSearchHistory: T[] | undefined
) => {
  return useCallback(
    (newQuery: string, isRegex?: boolean) => {
      const searchHistory = produceSearchHistory(
        newQuery,
        currentSearchHistory,
        undefined,
        isRegex
      );
      if (!searchHistory) {
        return;
      }
      updateSearchHistory(searchHistory);
    },
    [updateSearchHistory, currentSearchHistory]
  );
};
